import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

export const ProblemSolution = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center space-y-12">
          <div className="space-y-6">
            <div className="inline-block">
              <div className="bg-red-50 text-red-700 px-4 py-2 rounded-full text-sm font-medium">
                {t('problemSolution.theChallenge')}
              </div>
            </div>
            <p className="text-2xl md:text-3xl text-gray-900 font-medium leading-relaxed">
              "{t('problemSolution.challengeText')}"
            </p>
          </div>

          <div className="space-y-6">
            <div className="inline-block">
              <div className="bg-green-50 text-green-700 px-4 py-2 rounded-full text-sm font-medium">
                {t('problemSolution.theSolution')}
              </div>
            </div>
            <p className="text-2xl md:text-3xl text-gray-900 font-medium leading-relaxed">
              "{t('problemSolution.solutionText')}"
            </p>
          </div>
        </div>
      </div>
    </section>;
};